export const PAGE_SECTIONS_ID = [
  {
    sectionId: "todays-section",
    pagePath: "/",
  },
  {
    sectionId: "account-page",
    pagePath: "/profile",
  },
  {
    sectionId: "details-page",
    pagePath: "/details/",
  },
  {
    sectionId: "cart-page",
    pagePath: "/cart",
  },
  {
    sectionId: "wishlist-page",
    pagePath: "/wishlist",
  },
  {
    sectionId: "login-page",
    pagePath: "/login",
  },
  {
    sectionId: "signup-page",
    pagePath: "/signup",
  },
  {
    sectionId: "about-page",
    pagePath: "/about",
  },
  {
    sectionId: "contact-page",
    pagePath: "/contact",
  },
  {
    sectionId: "checkout-page",
    pagePath: "/checkout",
  },
  {
    sectionId: "favorite-page",
    pagePath: "/favorites",
  },
  {
    sectionId: "search-page",
    pagePath: "/search",
  },
  {
    sectionId: "details-section",
    pagePath: "/details",
  },
  {
    sectionId: "products-section",
    pagePath: "/products",
  },
  {
    sectionId: "notfound-page",
  },
];
